import { TRule } from '../../typings';

export const INTERCARS_PRICELIST_RULESET: TRule[] = [
  {
    type: 'rule.map',
    sourceKey: 'c.ean',
    destination: 'product',
    targetKey: 'ean',
  },
  {
    type: 'rule.map',
    sourceKey: "c.['Manufacturer_Code']",
    destination: 'product',
    targetKey: 'manufacturerCode',
  },
  {
    type: 'rule.operate',
    sourceKey: 'c.customer_price',
    destination: 'product',
    targetKey: 'priceEUR',
    operationName: 'getIntercarsPrice',
  },
];
